import React from 'react';
import './FeaturedProperties.css';

export default function FeaturedProperties() {
  const properties = [
    {
      name: 'The Grand Marina',
      location: 'Mumbai, Maharashtra',
      rating: 8.9,
      reviews: '1,204',
      sentiment: 'Excellent',
      price: '₹4,250',
      image: '/assets/1000026.jpg',
    },
    {
      name: 'Sunset Beach Resort',
      location: 'Calangute, Goa',
      rating: 9.2,
      reviews: '980',
      sentiment: 'Superb',
      price: '₹6,100',
      image: '/assets/605651288.jpg',
    },
    {
      name: 'Heritage Haveli',
      location: 'Jaipur, Rajasthan',
      rating: 8.7,
      reviews: '642',
      sentiment: 'Very good',
      price: '₹3,800',
      image: '/assets/623712193.webp',
    },
    {
      name: 'Pine Valley Cottage',
      location: 'Manali, Himachal',
      rating: 9.0,
      reviews: '510',
      sentiment: 'Superb',
      price: '₹5,400',
      image: '/assets/767082867.webp',
    },
  ];

  return (
    <section className="block">
      <div className="container">
        <div className="section-head">
          <h2>Homes guests love</h2>
        </div>
        <div className="grid grid-4">
          {properties.map((prop, idx) => (
            <div key={idx} className="prop-card">
              <div className="imgslot" data-label={prop.image}>
                <img src={prop.image} alt={prop.name} onError={(e) => (e.target.style.display = 'none')} />
              </div>
              <div className="body">
                <h4>{prop.name}</h4>
                <div className="loc">{prop.location}</div>
                <div className="rate">
                  <span className="score">{prop.rating}</span>
                  <span>
                    {prop.sentiment} · {prop.reviews} reviews
                  </span>
                </div>
                <div className="price">
                  {prop.price} <small>per night</small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
